import { render } from "./OpenBoxModal.vue?vue&type=template&id=bf48d57e&scoped=true"
import script from "./OpenBoxModal.vue?vue&type=script&lang=js"
export * from "./OpenBoxModal.vue?vue&type=script&lang=js"

import "./OpenBoxModal.vue?vue&type=style&index=0&id=bf48d57e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf48d57e"]])

export default __exports__